import { render } from "./TemplateSidebar.vue?vue&type=template&id=337a375e"
import script from "./TemplateSidebar.vue?vue&type=script&lang=js"
export * from "./TemplateSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__